import { useState } from 'react';
import { toast } from 'react-toastify';
import useAuth from './useAuth';
import { sendSupportTicket } from '../api/supportApi';

export const useSupport = () => {
  const { user } = useAuth();
  
  const [formData, setFormData] = useState({
    nombre: user?.nombre || '',
    correo: '',
    telefono: '',
    mensaje: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.nombre || !formData.correo || !formData.mensaje) {
      toast.error('Complete los campos obligatorios (*).');
      return;
    }

    setLoading(true);
    
    try {
      const data = await sendSupportTicket(formData);

      if (data.success) {
        toast.success(data.mensaje || '¡Solicitud enviada con éxito!');
        setFormData({ 
          nombre: user?.nombre || '', 
          correo: '', 
          telefono: '', 
          mensaje: '' 
        });
      } else {
        toast.error(data.mensaje || 'Hubo un problema enviando la solicitud.');
      }
    } catch (err) {
      console.error('Error enviando soporte:', err);
      toast.error('Error de conexión con el servidor.');
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    handleChange,
    handleSubmit
  };
};
